import { useEffect, useState } from 'react';
import {
  RuntimeLoader,
  useRive as useRiveOriginal, //eslint-disable-line no-restricted-imports
  type UseRiveParameters,
  type UseRiveOptions,
} from '@rive-app/react-canvas-lite';

import wasm from '@rive-app/canvas-lite/rive.wasm';

RuntimeLoader.setWasmUrl(wasm);

let wasmLoaded = false;
// Kick off loading at module import time so wasmLoaded can be true before the first
// render if this module was imported early. .catch() suppresses the unhandled
// rejection at module scope; the hook's useEffect handles the error path.
RuntimeLoader.awaitInstance()
  .then(() => { wasmLoaded = true; })
  .catch(() => { /*noop*/ });

type UseRiveWrappedParameters = Omit<NonNullable<UseRiveParameters>, 'onLoadError'> | null;

const useRive = (params: UseRiveWrappedParameters, opts?: Partial<UseRiveOptions>) => {
  const [failed, setFailed] = useState(false);
  const [isWasmLoaded, setIsWasmLoaded] = useState(() => wasmLoaded);

  useEffect(() => {
    let cancelled = false;
    RuntimeLoader.awaitInstance()
      .then(() => {
        if (!cancelled) setIsWasmLoaded(true);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => { cancelled = true; };
  }, []);

  const riveState = useRiveOriginal(
    params ? { ...params, onLoadError: () => setFailed(true) } : null,
    opts
  );

  return { ...riveState, failed: failed || !isWasmLoaded };
};

export default useRive;
